import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Navbar from "../components/Navbars/Navbar.js";

import routes from "../routes.js";

import styles from "../assets/jss/material-dashboard-react/layouts/adminStyle.js";
import EditCriterion from "../views/Criteria/EditCriterion";
import WizardWelcomeScreen from "../views/InputData/WizardWelcomeScreen";
import Login from "../views/Login/Login";
import Results from "../views/Results/Results";
import ShowCriteria from "../views/Criteria/ShowCriteria";
import EditCriteria from "../views/Criteria/EditCriteria";
import CreateCriteria from "../views/Criteria/CreateCriteria";
import ImportData from "../views/ImportData/ImportData";
import Home from "../components/Home/Home";

let ps;

const switchRoutes = (
  <Switch>
    <Route path="/admin/login" component={Login} />
    <Route path="/admin/inputData" component={WizardWelcomeScreen} />
    <Route path="/admin/importData" component={ImportData} />
    <Route path="/admin/results" component={Results} />
    <Route path="/admin/showallcriteria" component={ShowCriteria} />
    <Route path="/admin/createcriteria" component={CreateCriteria} />
    <Route path="/admin/editcriteria" component={EditCriteria} />
    <Route path="/admin/editCriterion/:id" component={EditCriterion} />
    <Route path="*" component={Home} />
    <Redirect from="/admin" to="/admin/dashboard" />
  </Switch>
);

const useStyles = makeStyles(styles);

export default function Admin({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
      </div>
    </div>
  );
}
